import { z } from "zod";
import { productDefinitionSchema } from "../../products/schemas/productDefinitionSchema";
import { uuid } from "../../schema-validation/schemes";
import { ETaskDefinitionTemplateScope } from "../ETaskDefinitionTemplateScope";

export const taskDefinitionEmployeeRequirementSchema = z.object({
  source: z.string(),
  category: z.enum([
    "profile",
    "userAccount",
    "bankAccount",
    "w4",
    "td1",
    "idDocuments",
  ]),
  fields: z.array(z.string()),
});

export const taskDefinitionCompanyRequirementSchema = z.object({
  source: z.string(),
  fields: z.array(z.string()),
});

export const taskDefinitionTemplateRequirementsSchema = z.object({
  employee: z.array(taskDefinitionEmployeeRequirementSchema),
  company: z.array(taskDefinitionCompanyRequirementSchema).default([]),
  whitelabel: z.array(taskDefinitionCompanyRequirementSchema).default([]),
});

export const taskDefinitionTemplateSchema = z.object({
  taskDefinitionTemplateId: uuid(),
  productDefinitionId: uuid(),
  scope: z
    .nativeEnum(ETaskDefinitionTemplateScope)
    .default(ETaskDefinitionTemplateScope.Company),
  requirements: taskDefinitionTemplateRequirementsSchema
    .optional()
    .default({ employee: [], company: [], whitelabel: [] }),
});

export type ZTaskDefinitionTemplate = z.infer<
  typeof taskDefinitionTemplateSchema
>;

export const taskDefinitionTemplateRefsPopulatedSchema =
  taskDefinitionTemplateSchema.extend({
    productDefinition: productDefinitionSchema.pick({
      product: true,
      description: true,
      productType: true,
    }),
  });

export type ZTaskDefinitionTemplateRefsPopulated = z.infer<
  typeof taskDefinitionTemplateRefsPopulatedSchema
>;
